import { render, staticRenderFns } from "./UserManagerAddUser.vue?vue&type=template&id=72780cec&scoped=true&"
import script from "./UserManagerAddUser.vue?vue&type=script&lang=js&"
export * from "./UserManagerAddUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72780cec",
  null
  
)

export default component.exports